module.exports = __webpack_public_path__ + "img/math_hi.288b0121.jpg";